/// Port of mobile/lib/game/sky/sun.dart.

import { SpriteComponent, sprite } from '../engine/sprite';
import { worldWidth } from '../world';
import { skyAssets } from './skyAssets';

/// Fixed sun in the top-right of the day sky.
export class Sun extends SpriteComponent {
  static readonly marginRight = 48.0;
  static readonly marginTop = 10.0;
  static readonly dim = 40.0;

  constructor() {
    const size = { x: Sun.dim, y: Sun.dim };
    super({
      size,
      priority: -1,
      sprite: sprite(skyAssets.sun, size),
      position: { x: worldWidth - Sun.marginRight - Sun.dim, y: Sun.marginTop },
    });
  }
}
